import React from 'react'
import Icon from 'components/Icon'
import { IconButton } from 'components/IconButton'
import { observer } from 'mobx-react'
import styles from './DetailsHeader.sass'

interface DetailsHeaderProps {
  onClose: () => void
}

export default observer(function DetailsHeader({
  onClose,
}: DetailsHeaderProps) {
  return (
    <div className={styles.header}>
      <IconButton onClick={onClose}>
        <Icon name="back" size={24} />
      </IconButton>
    </div>
  )
})
